export enum BrandLetter {
  Other = 'other',
}
